import { ClassAttributes, createElement } from 'react';

import { Consumer as StateConsumer } from '../context/state';
import _SignedOutScreen from '../screen/SignedOutScreen';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SignedOutScreen = ({ className }: Props) => {
  return (
    <StateConsumer>
      {(state) =>
        state.authentication.fetching === 0 &&
        !state.authentication.signedInUser &&
        Object.keys(state.translations).length !== 0 ? (
          <_SignedOutScreen className={className} />
        ) : null
      }
    </StateConsumer>
  );
};

export default SignedOutScreen;
